<div class="main-wrapper-section">
    <div class="common-header">
        <h3>MemberShip Dashboard</h3>
    </div>
    <div class="card-section">
        <div class="card-panel">
            <div class="field-form-panel">
                <div class="flex-form contracts-flex-form top-filter-panel">
                    <div class="form-group">
                        <label>Site</label>
                        <input class="form-control" />
                    </div>
                    <div class="form-group">
                        <label>Manager</label>
                        <select class="form-control">
                            <option>Heelo World</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label>Contract Status</label>
                        <input class="form-control" />
                    </div>
                    <div class="form-group">
                        <label>Time Frame</label>
                        <input class="form-control" />
                    </div>
                    <div class="form-group">
                        <label>Sample</label>
                        <input class="form-control" />
                    </div>
                    <div class="form-group">
                        <label></label>
                        <div class="button-group">
                            <input matInput class="form-control" placeholder="Search">
                        </div>
                    </div>
                </div>
            </div>
            <div class="">
                <div class="button-group" style="border:none;">
                    <button class="primary-btn">Add</button>
                </div>
            </div>
            <div class="table-panel">
                <div class="table-body">

                </div>
            </div>
        </div>
    </div>
</div>

